import MobileHeader from "../../../layout/OwnerLayout/Header";
import { Box, Divider, Typography, useTheme } from "@mui/material";
import ArrowTickLeft from "../../../../media/images/icons/arrow-tick-left";
import { blueGrey, grey } from "@mui/material/colors";
import SmsTrackingIcon from "../../../../media/images/icons/sms-tracking";
import InfoTriangle from "../../../../media/images/icons/info-triangle";
import CustomInput from "../../../components/CustomInput";
import CustomButton from "../../../components/CustomButton";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../services/fetcher";
import { useAppDispatch, useAppSelector } from "../../../../hooks/useRedux";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../redux/features/snackbarSlice";
import {
  setDialogStatus,
  setDialogTitle,
  setOpenDialog,
} from "../../../../redux/features/dialogSlice";
import OtpInput from "../../SignupPage/components/OtpInput";
import { PreventInputAlpha } from "../../../../utils/functions";
import React, { useState } from "react";
import useLogout from "../../../../hooks/useLogout";

export default function OwnerChangeMobilePage() {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [otpSent, setOtpSent] = useState(false);
  const [handleLogout] = useLogout();

  const { ownerInfo } = useAppSelector((state) => state.owner);

  const phoneFormik = useFormik({
    initialValues: {
      phoneNumber: "",
    },
    validationSchema: yup.object().shape({
      phoneNumber: yup
        .string()
        .matches(/^09[0-9]{9}$/, "شماره همراه وارد شده صحیح نیست!")
        .required("این فیلد الزامی است!"),
    }),
    validateOnChange: true,
    onSubmit: () => {
      sendCodeTrigger({ phoneNumber: phoneFormik.values.phoneNumber });
    },
  });

  const otpFormik = useFormik({
    initialValues: {
      code: "",
    },
    validationSchema: yup.object().shape({
      code: yup
        .string()
        .min(4, "کد وارد شده صحیح نیست!")
        .required("این فیلد الزامی است!"),
    }),
    validateOnChange: true,
    onSubmit: () => {
      confirmChangeTrigger({
        phoneNumber: phoneFormik.values.phoneNumber,
        code: Number(otpFormik.values.code),
      });
    },
  });

  const { trigger: sendCodeTrigger, isMutating: isSendingCode } =
    useSWRMutation(
      [`/Account/SendCodeToValidateNumber`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: () => {
          setOtpSent(true);
        },
        onError: (error: any) => {
          dispatch(setSnackbarErrorStatus(error?.response?.data?.errorCode || 400));
          dispatch(setSnackbarDescription(error?.response?.data?.error || "ارسال کد با خطا مواجه شد!"));
          dispatch(setOpenSnackbar(true));
        },
      }
    );

  const { trigger: confirmChangeTrigger, isMutating: isConfirming } =
    useSWRMutation(
      [`/Account/ConfirmChPhoneNumber`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: () => {
          console.log("[OwnerChangeMobile] Phone changed successfully, logging out to refresh user data...");
          dispatch(setOpenDialog(true));
          dispatch(setDialogStatus("success"));
          dispatch(setDialogTitle("شماره همراه تغییر کرد. لطفاً مجدداً وارد شوید."));
          setTimeout(() => {
            dispatch(setOpenDialog(false));
            console.log("[OwnerChangeMobile] Clearing session and redirecting to login...");
            handleLogout();
          }, 3000);
        },
        onError: (error: any) => {
          dispatch(setSnackbarErrorStatus(error?.response?.data?.errorCode || 400));
          dispatch(setSnackbarDescription(error?.response?.data?.error || "کد وارد شده اشتباه است!"));
          dispatch(setOpenSnackbar(true));
        },
      }
    );

  return (
    <>
      <MobileHeader title={<HeadTitle />} hasScroll={false} />
      <Box sx={{ flex: 1, paddingX: "8px" }}>
        <Box
          sx={{
            border: "1px solid",
            borderColor: blueGrey[100],
            backgroundColor: "bgColor.white",
            padding: "16px",
            borderRadius: "10px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "4px",
            }}
          >
            <SmsTrackingIcon color={theme.palette.primary.main} size={24} />
            <Typography sx={{ color: "primary.main", fontWeight: "700" }}>
              تغییر شماره همراه
            </Typography>
          </Box>

          <Box
            sx={{
              marginTop: "8px",
              backgroundColor: theme.palette.primary[50],
              padding: "10px 12px",
              borderRadius: "10px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <InfoTriangle color={theme.palette.primary.main} />
              <Typography sx={{ fontSize: "16px", color: "primary.main" }}>
                توجه:
              </Typography>
            </Box>
            <Typography sx={{ color: "primary.main", fontSize: "14px" }}>
              شماره همراه جدید باید به نام شما ثبت شده باشد و با کد ملی شما
              مطابقت داشته باشد.
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              marginTop: "8px",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <Typography
                sx={{ color: "primary.main", fontSize: "14px", fontWeight: "700" }}
              >
                شماره همراه فعلی
              </Typography>
              <CustomInput
                disabled
                value={ownerInfo?.phoneNumber || ""}
                placHolder="شماره همراه فعلی"
                direction="ltr"
              />
            </Box>

            <Divider variant="middle" />

            <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <Typography
                sx={{ color: "primary.main", fontSize: "14px", fontWeight: "700" }}
              >
                شماره همراه جدید
              </Typography>
              <CustomInput
                type="tel"
                name="phoneNumber"
                placHolder="09121234567"
                direction="ltr"
                disabled={otpSent}
                value={phoneFormik.values.phoneNumber}
                handelChange={(e) => {
                  if (e.target.value.length > 11) return;
                  PreventInputAlpha(e, phoneFormik.handleChange);
                }}
                error={
                  phoneFormik.touched.phoneNumber &&
                  Boolean(phoneFormik.errors.phoneNumber)
                }
                errorMessage={
                  phoneFormik.touched.phoneNumber &&
                  phoneFormik.errors.phoneNumber
                }
              />
            </Box>

            {otpSent && (
              <OtpInput
                name="code"
                mobileNumber={phoneFormik.values.phoneNumber}
                value={otpFormik.values.code}
                handleChange={(e) => {
                  if (e.target.value.length > 6) return;
                  PreventInputAlpha(
                    e as React.ChangeEvent<HTMLInputElement>,
                    otpFormik.handleChange
                  );
                }}
                error={otpFormik.touched.code && Boolean(otpFormik.errors.code)}
                errorMessage={otpFormik.touched.code && otpFormik.errors.code}
                sendOtpState={(isFinished) => {
                  if (isFinished) setOtpSent(false);
                }}
              />
            )}

            <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <CustomButton
                flex={1}
                justifyContent="center"
                onClick={() => navigate(-1)}
                bgColor={theme.palette.primary[50]}
                title={"انصراف"}
                fSize="16px"
                fWeight="700"
                borderColor={theme.palette.primary.main}
                py="10px"
                px="6px"
                gap="4px"
                borderRadius="6px"
                textColor={theme.palette.primary.main}
              />
              <CustomButton
                flex={1}
                loading={isSendingCode || isConfirming}
                justifyContent="center"
                onClick={async () => {
                  if (!otpSent) {
                    const errors = await phoneFormik.validateForm();
                    if (Object.keys(errors).length > 0) {
                      phoneFormik.setTouched({ phoneNumber: true });
                    } else {
                      phoneFormik.handleSubmit();
                    }
                  } else {
                    const errors = await otpFormik.validateForm();
                    if (Object.keys(errors).length > 0) {
                      otpFormik.setTouched({ code: true });
                    } else {
                      otpFormik.handleSubmit();
                    }
                  }
                }}
                bgColor={"primary.main"}
                title={otpSent ? "تایید و ذخیره شماره" : "ارسال کد تایید"}
                fSize="16px"
                fWeight="700"
                py="10px"
                px="6px"
                gap="4px"
                borderRadius="6px"
                textColor={"#fff"}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

function HeadTitle() {
  const navigate = useNavigate();
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Typography
        onClick={() => navigate("../profile")}
        sx={{
          cursor: "pointer",
          color: "secondary.main",
          fontWeight: 600,
          fontSize: "14px",
        }}
      >
        حساب کاربری من
      </Typography>
      <ArrowTickLeft size={16} color={grey[800]} />
      <Typography sx={{ color: "secondary.main", fontSize: "12px", fontWeight: 600 }}>
        تغییر شماره همراه
      </Typography>
    </Box>
  );
}
